let host = window.location.host
export default {
    apiBasePath: process.env.NODE_ENV == "production"
        ? "/prod-api/"
        // : "//47.113.198.234/bluewhale/",
        : "//localhost:1010/",
    tokenName: "_blue_whale_token_",
    userInfoName: "_blue_whale_user_info_"
}
